export const SET_VIEWPORT_DIMENSIONS = 'brower/SET_VIEWPORT_DIMENSIONS';
export const SET_VIEWPORT_ORIENTATION = 'browser/SET_VIEWPORT_ORIENTATION';
export const SET_VIEWPORT_SIZE = 'browser/SET_VIEWPORT_SIZE';